import { ISearchParamName, ISearchParamNameAndValue, SearchParamName } from '@cbridge-packages/routing';

export namespace NodeParam {
  export const name: ISearchParamName = {
    name: SearchParamName.SymbolPool,
  };

  export function nameAndValue(value: ISearchParamNameAndValue['value']): ISearchParamNameAndValue {
    return {
      ...name,
      value,
    };
  }
}
